import lang from "../../lib/appfuse-react/core/lang";
import newborns from "../caseInfo/newborns";

const testListService = [{
    matcher: 'testList',
    reply: config => {
        if(config.method==='post') {
            return [200, newborns[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            const children = predicate?.node()?.children?.();
            if (lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, newborns];
                }
                if(selector==='motherName') {
                    const regexp = new RegExp(value.replaceAll('*', '.*'));
                    data = newborns.filter(newborn => regexp.test(newborn[selector]));
                } else if(selector==='no' || selector==='medicalRecordNo') {
                    data = newborns.filter(newborn => newborn[selector]===value);
                } else if(selector==='collectionDateStart') {
                    data = newborns.filter(newborn => newborn['collectionDate'] >= value);
                } else if(selector==='collectionDateEnd') {
                    data = newborns.filter(newborn => newborn['collectionDate'] <= value);
                }
            } else if(lang.isNotEmpty(children)) {
                let tmp = newborns;
                for(let child of children) {
                    const value = child.expectation();
                    if(lang.isEmpty(value)) {
                        continue;
                    }
                    const selector = child.selector();
                    if(selector==='motherName' && lang.isNotEmpty(value)) {
                        const regexp = new RegExp(value.replaceAll('*', '.*'));
                        tmp = tmp.filter(newborn => regexp.test( newborn[selector]));
                    } else if((selector==='no' || selector==='medicalRecordNo') && lang.isNotEmpty(value)) {
                        tmp = tmp.filter(newborn => newborn[selector]===value);
                    } else if(selector==='collectionDateStart' && lang.isNotEmpty(value)) {
                        tmp = tmp.filter(newborn => newborn['collectionDate'] >= value);
                    } else if(selector==='collectionDateEnd' && lang.isNotEmpty(value)) {
                        tmp = tmp.filter(newborn => newborn['collectionDate'] <= value);
                    }
                }
                data = tmp;
            } else {
                data = newborns;
            }
            return [200, data];
        }
    }
}, {
    matcher: /testList\/(.*)/,
    reply: config => {
        const id = /testList\/(.*)/.exec(config.url)[1];
        const newborn = newborns.find(newborn => newborn.no === id);
        return [200, newborn];
    }
}];

export default testListService;